'user strict';

import { createSelector } from 'reselect';

export const getErrors = (state, props) => {
	return state.errors;
};
